/**
 * Shared "By continuing you agree to <terms> and <privacy>" footer used by the
 * 90-day trial-recap upgrade modals (Clinician / Practice).
 */

import { Link } from '@heidi/design-system/link';
import { FormattedMessage, defineMessage } from 'react-intl';

export type UpgradeTermsFooterProps = {
  /** Locale-resolved terms-of-use URL, supplied by the composition point. */
  termsHref: string;
  /** Privacy/usage-policy URL, supplied by the composition point. */
  privacyHref: string;
};

const upgradeTermsFooterMessage = defineMessage({
  defaultMessage:
    'By continuing you agree to <termsLink>Terms of use</termsLink> and <privacyLink>privacy policy</privacyLink>.',
  id: 'X1zfz1pdjP',
  description:
    'Trial-recap upgrade modal footer (Clinician / Practice): terms of use and privacy policy links shown before the user continues with the upgrade',
});

export const UpgradeTermsFooter = ({
  termsHref,
  privacyHref,
}: UpgradeTermsFooterProps) => (
  <FormattedMessage
    {...upgradeTermsFooterMessage}
    values={{
      termsLink: (chunks) => (
        <Link variant="inline" href={termsHref} target="_blank" rel="noopener noreferrer">
          {chunks}
        </Link>
      ),
      privacyLink: (chunks) => (
        <Link
          variant="inline"
          href={privacyHref}
          target="_blank"
          rel="noopener noreferrer"
        >
          {chunks}
        </Link>
      ),
    }}
  />
);
